import React from "react";

/*eslint-disable */

declare const window: any;
const TitleComponent: React.FC = () => {
  return (
    <h1 className="title-politicas-component">Términos y Condiciones</h1>
  );
};

export default TitleComponent;
